export const stringMapDefault = {
    /** text for labeling the navigation list */
    navList: "Navigation List",
    /** contents for mobile menu tooltip */
    mobileMenuButtonTooltip: "Toggle Menu",
    /** mobile menu icon aria label */
    mobileMenuIcon: "Toggle Menu",
    /** aria label for overflow icon button */
    overflowIconButton: "More Items"
};
